<template>
  <div class="information-page">
    <div v-if="skeleton || skeleton2" class="skeleton">
      <van-skeleton title :row="20" />
    </div>

    <main v-else class="information-content">
      <section class="promo-banner">
        <div class="hero-brand">
          <span class="brand-mark"><img src="../assets/images/logo-large.png" alt="海平创新知识服务" /></span>
          <div>
            <strong>{{ form.businessCard.company || "深圳海平创新知识服务公司" }}</strong>
            <span>专注供应链数字化与风险控制</span>
          </div>
          <button class="card-entry" type="button" @click="goCard">
            <van-icon name="contact" />
            <span>个人名片</span>
          </button>
        </div>
        <div class="hero-copy">
          <h1>贸易业务合规与<br />风险控制</h1>
          <p>洞察规则 · 识别风险 · 守护业务增长</p>
          <button class="primary-action" type="button" @click="go('/guoqi')">
            立即查看 <van-icon name="arrow" />
          </button>
          <time>更新于 2026-09-02</time>
        </div>
      </section>

      <section class="stat-card-grid" aria-label="数据概览">
        <button class="stat-card" type="button" @click="go('/guoqi')">
          <span class="stat-icon"><img src="../assets/images/stat-list.png" alt="" /></span>
          <span class="stat-content">
            <strong>假央企名单</strong>
            <span>已收录 <em>{{ fakeSoeTotal }}</em></span>
          </span>
        </button>
        <button class="stat-card" type="button" @click="go('/trail')">
          <span class="stat-icon"><img src="../assets/images/stat-check.png" alt="" /></span>
          <span class="stat-content">
            <strong>贸易合规自查表</strong>
            <span>已下载 <em>134</em></span>
          </span>
        </button>
      </section>

      <section class="service-strip" aria-label="贸易服务">
        <button type="button" @click="goWzf()">
          <img src="../assets/images/service-globe.png" alt="外贸综合服务平台" />
          <strong>外贸综合服务平台</strong>
          <span>代办退税、结汇、报关</span>
        </button>
        <button type="button" @click="go('/opportunity')">
          <img src="../assets/images/service-database.png" alt="大宗贸易平台" />
          <strong>大宗贸易平台</strong>
          <span>产业资源对接</span>
        </button>
        <button type="button" @click="go('/guoqi')">
          <img src="../assets/images/service-ai-risk.png" alt="AI风控报告" />
          <strong>AI风控报告</strong>
          <span>智能识别 · 预警</span>
        </button>
      </section>

      <section class="mini-program-banner">
        <span>中国供应链第一神图8.0正在发售！</span>
        <van-icon name="arrow" />
        <wx-open-launch-weapp
          class="mini-program-launch"
          username="gh_b7bbf3c44d05"
          path="pages/DivineList/index"
        >
          <script type="text/wxtag-template">
            <style>
              .mini-program-launch-button {
                width: 100%;
                height: 100%;
                opacity: 0;
              }
            </style>
            <button class="mini-program-launch-button" type="button" aria-label="打开中国供应链第一神图8.0"></button>
          </script>
        </wx-open-launch-weapp>
      </section>

      <section class="headline-section">
        <header class="headline-heading">
          <div>
            <h2>头条资讯</h2>
            <span></span>
          </div>
          <!-- <button type="button" @click="go('/flow')">查看更多 <van-icon name="arrow" /></button> -->
        </header>

        <ul class="article-list">
          <li v-for="(item, index) in list" :key="item.id" @click="goD(item)">
            <article>
              <span class="article-index" :class="{ featured: index === 0 }">{{ String(index + 1).padStart(2, '0') }}</span>
              <div class="article-body">
                <h3>{{ formatTitle(item.name) }}</h3>
                <p>{{ formatSummary(item.summary) }}</p>
                <footer>
                  <span><van-icon name="eye-o" /> {{ item.readQty || 0 }}阅读</span>
                  <time>{{ item.createTime }}</time>
                </footer>
              </div>
            </article>
          </li>
        </ul>

        <div v-if="loading || (finished && list.length)" class="list-more">
          <van-loading v-if="loading" size="18px" color="#ef4f16">正在加载更多…</van-loading>
          <span v-else class="list-end">已经到底了</span>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import mixin from "../utils/share";
import ladingPage from "../utils/ladingPage";

export default {
  name: "Home",
  mixins: [mixin, ladingPage],
  data () {
    return { 
      pageNum: 1, 
      skeleton2: true, 
      form2: {}, 
      list: [], 
      loading: false, 
      finished: false, 
      fakeSoeTotal: 0 
    };
  },
  created () {
    this.getFakeSoeCount();
    this.getList();
    this.$api.get(`/api/crm/businessCard/get?id=${this.$route.query.id}`).then((res) => {
      this.form2 = res.result;
      this.skeleton = false;
      this.$nextTick(() => {
        this.form.businessCard = res.result || {};
        localStorage.setItem("tel", this.form.businessCard.mobile);
        localStorage.setItem("www", this.form.businessCard.www);
        localStorage.setItem("id", this.form.id);
        localStorage.setItem("businessCardId", this.form.businessCard.id);
        localStorage.setItem("address", `http://apis.map.qq.com/uri/v1/marker?marker=coord:${this.form.businessCard.lat},${this.form.businessCard.lng};title:${this.form.businessCard.company};addr:${this.form.businessCard.address}`);
        localStorage.setItem("productUrl", this.form.businessCard.productUrl || "");
        localStorage.setItem("openProduct", this.form.businessCard.openProduct || false);
        this.share();
        this.geet();
      });
    });
  },
  mounted () {
    window.onscroll = () => {
      if (this.$route.name === "flow") return;
      if (this.loading || this.finished) return;
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      // 距底部不足 80px 时加载下一页
      if (scrollHeight - scrollTop - windowHeight < 80) {
        this.pageNum += 1;
        this.getList();
      }
    };
  },
  beforeDestroy () {
    window.onscroll = null;
  },
  methods: {
    getFakeSoeCount () {
      // 假央企名单数量：labels 含“假央企”的黑名单记录总数，取 result.total
      this.$api.post("/api/crm/blackList/list", {
        pageNum: 1,
        pageSize: 1,
        data: {},
        params: { "labels$LIKE": "假央企" },
      }).then((res) => {
        if (res && res.result) {
          this.fakeSoeTotal = res.result.total || 0;
        }
      });
    },
    getList () {
      if (this.loading) return;
      const pageSize = 10;
      this.loading = true;
      this.$api.post("/api/crm/article/list", { pageNum: this.pageNum, pageSize, orderByDesc: "createTime" }).then((res) => {
        if (res && res.result) {
          const defaultIds = [9658002480824320, 9658001230921728, 9657999577907200, 867024656400384, 1036973216169984];
          const raw = res.result.list || [];
          const existed = {};
          this.list.forEach((item) => { existed[item.id] = true; });
          const array = raw.filter((item) => !defaultIds.includes(item.id) && !existed[item.id]);
          if (raw.length < pageSize) {
            this.finished = true;
          }
          this.list = [...this.list, ...array];
          this.skeleton2 = false;
          if (this.list.length) {
            this.form.article = { name: this.list[0].name, summary: this.list[0].summary, $id: this.list[0].id };
            this.geet();
          }
        }
      }).then(() => {
        // 接口失败时 api.js 的 catch 已把 res 置为 false，这里统一收尾，避免 loading 卡死
        this.loading = false;
      });
    },
    goD (item) {
      this.$router.push(`/details?id=${localStorage.getItem("ladingPageId") || 0}&businessCardId=${this.form.businessCard.id}&channelId=${localStorage.getItem("channelId") || 0}&articleId=${item.id}`);
    },
    go (url) {
      this.$router.push(url);
    },
    goWzf () {
      window.location.href = 'http://jd.demo.zhongpukeji.cn/#/index'
    },
    goCard () {
      const businessCardId = this.form.businessCard.id || localStorage.getItem("businessCardId") || this.$route.query.id || "";
      this.$router.push(`/card?id=${businessCardId}`);
    },
    mountMiniProgramTag () {
      // 微信开放标签由模板直接渲染，这里保留方法避免旧缓存调用报错。
    },
    formatSummary (summary) {
      const text = String(summary || "持续关注国际贸易规则与业务风险变化。").replace(/\s+/g, " ").trim();
      return text.length > 56 ? `${text.slice(0, 56)}...` : text;
    },
    formatTitle (title) {
      const text = String(title || "贸易业务合规与风险控制").replace(/\s+/g, " ").trim();
      return text.length > 80 ? `${text.slice(0, 80)}...` : text;
    },
  },
};
</script>

<style lang="less" scoped>
@page-bg: #faf7f1;
@surface: #fffdfc;
@ink: #142033;
@body: #333a45;
@muted: #7f858d;
@brand: #ef4f16;
@brand-light: #f47a3c;
@brand-soft: #fff1e8;
@gold: #d7a34a;
@line: #e9e6e1;

button { margin: 0; padding: 0; border: 0; color: inherit; font: inherit; background: transparent; appearance: none; }
.information-page { min-height: 100vh; color: @ink; background: @page-bg; font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", sans-serif; }
.information-content { max-width: 750px; margin: 0 auto; padding-bottom: 32px; }

.promo-banner { position: relative; height: 540px; overflow: hidden; padding: 38px 40px 0; background: @page-bg url("../assets/images/trade-compliance-hero.png") center / cover no-repeat; }
.hero-brand { position: relative; z-index: 1; display: flex; align-items: center;
  .brand-mark { display: flex; align-items: center; justify-content: center; width: 62px; height: 62px; margin-right: 18px; border-radius: 50%; }
  .brand-mark img { display: block; width: 100%; height: 100%; object-fit: contain; }
  > div { display: flex; flex-direction: column; min-width: 0; }
  strong { overflow: hidden; color: @ink; font-family: "Songti SC", "STSong", "SimSun", serif; font-size: 28px; font-weight: 700; line-height: 1.25; text-overflow: ellipsis; white-space: nowrap; }
  > div > span { margin-top: 6px; color: @muted; font-size: 20px; }
  .card-entry { display: inline-flex; align-items: center; gap: 10px; margin-left: auto; color: @ink; font-size: 22px; white-space: nowrap; }
  .card-entry .van-icon { font-size: 31px; }
}
.hero-copy { position: relative; z-index: 1; margin-top: 69px;
  h1 { color: @ink; font-family: "Songti SC", "STSong", "SimSun", serif; font-size: 66px; font-weight: 800; line-height: 1.18; letter-spacing: 1px; }
  p { margin-top: 20px; color: #656d77; font-size: 24px; letter-spacing: 1px; }
  .primary-action { display: inline-flex; align-items: center; justify-content: center; gap: 12px; min-width: 214px; height: 62px; margin-top: 28px; padding: 0 30px; color: #fff; font-size: 27px; font-weight: 600; border-radius: 32px; background: linear-gradient(90deg, @brand, @brand-light); box-shadow: 0 9px 20px rgba(239,79,22,.2); }
  .primary-action .van-icon { font-size: 25px; }
  time { display: block; margin-top: 20px; color: @muted; font-size: 20px; }
}

.stat-card-grid { display: grid; grid-template-columns: repeat(2, minmax(0,1fr)); min-height: 144px; background: @surface; border-bottom: 1px solid @line; }
.stat-card { position: relative; display: flex; align-items: center; justify-content: center; min-width: 0; padding: 22px 18px; text-align: left; }
.stat-card:first-child::after { position: absolute; top: 50%; right: 0; width: 1px; height: 60px; background: @line; content: ""; transform: translateY(-50%); }
.stat-icon { display: flex; flex: 0 0 auto; align-items: center; justify-content: center; width: 78px; height: 78px; margin-right: 23px; border-radius: 50%; }
.stat-icon img { display: block; width: 100%; height: 100%; object-fit: contain; }
.stat-content { display: flex; flex-direction: column; min-width: 0; gap: 8px;
  strong { overflow: hidden; color: @ink; font-size: 27px; font-weight: 700; text-overflow: ellipsis; white-space: nowrap; }
  span { color: @muted; font-size: 22px; white-space: nowrap; }
  em { margin-left: 7px; color: @brand; font-size: 37px; font-style: normal; font-weight: 700; }
}

.service-strip { display: grid; grid-template-columns: repeat(3,1fr); min-height: 180px; padding: 23px 0 20px; background: @surface; border-bottom: 1px solid @line;
  button { display: flex; flex-direction: column; align-items: center; justify-content: center; min-width: 0; border-right: 1px solid @line; }
  button:last-child { border-right: 0; }
  img { display: block; width: 62px; height: 48px; object-fit: cover; object-position: top center; }
  strong { margin-top: 13px; color: @ink; font-size: 26px; font-weight: 550; white-space: nowrap; }
  span { margin-top: 7px; color: @muted; font-size: 20px; white-space: nowrap; }
}

.mini-program-banner { position: relative; display: flex; align-items: center; justify-content: center; gap: 14px; min-height: 140px; box-sizing: border-box; padding: 16px 40px; color: #fff; font-size: 30px; font-weight: 600; text-align: center; background: linear-gradient(90deg, #ef4f16, @brand-light); cursor: pointer;
  .van-icon { font-size: 23px; }
  .mini-program-launch { position: absolute; inset: 0; display: block; width: 100%; height: 100%; }
}
.headline-section { background: @surface; }
.headline-heading { display: flex; align-items: center; justify-content: space-between; padding: 32px 40px 22px;
  > div { display: flex; flex-direction: column; align-items: flex-start; }
  h2 { color: @ink; font-family: "Songti SC", "STSong", "SimSun", serif; font-size: 35px; line-height: 1; }
  > div > span { width: 34px; height: 5px; margin-top: 14px; border-radius: 3px; background: @brand; }
  > button { display: inline-flex; align-items: center; gap: 8px; color: @muted; font-size: 21px; }
  .van-icon { font-size: 20px; }
}
.article-list {
  li { position: relative; min-height: 240px; box-sizing: border-box; padding: 20px 40px 24px; overflow: hidden; cursor: pointer; }
  li::after { position: absolute; right: 40px; bottom: 0; left: 40px; height: 1px; background: @line; content: ""; }
  article { display: flex; align-items: flex-start; }
  .article-index { display: block; flex: 0 0 80px; padding-top: 3px; color: #9ca2a9; font-family: Georgia, "Times New Roman", serif; font-size: 50px; line-height: 1.1; text-align: right; transform: scaleY(1.08); transform-origin: top right; }
  .article-index.featured { color: @brand; }
  .article-body { display: flex; flex-direction: column; min-width: 0; padding-left: 23px; border-left: 2px solid @line; }
  li:first-child .article-body { border-left-color: @brand; }
  h3 { max-height: 174px; overflow: hidden; color: @ink; font-size: 30px; font-weight: 700; line-height: 1.45; }
  p { display: block; height: 65px; max-height: 65px; overflow: hidden; margin-top: 12px; color: @muted; font-size: 21px; line-height: 1.55; }
  footer { display: flex; align-items: center; justify-content: space-between; margin-top: 17px; color: #9ca2a9; font-size: 18px;
    span { display: flex; align-items: center; gap: 8px; }
    .van-icon { font-size: 23px; }
  }
}
.list-more { display: flex; align-items: center; justify-content: center; min-height: 92px; box-sizing: border-box; padding: 10px 40px 26px; color: #a9aeb5; font-size: 20px; }
.list-end { position: relative; padding: 0 28px; }
.list-end::before, .list-end::after { position: absolute; top: 50%; width: 64px; height: 1px; background: @line; content: ""; transform: translateY(-50%); }
.list-end::before { right: 100%; }
.list-end::after { left: 100%; }

@media (max-width: 420px) {
  .promo-banner { height: 420px; padding-right: 22px; padding-left: 22px; }
  .hero-brand { .brand-mark { width: 50px; height: 50px; margin-right: 12px; } strong { font-size: 28px; } > div > span { font-size: 20px; } .card-entry { gap: 5px; font-size: 16px; } .card-entry .van-icon { font-size: 24px; } }
  .hero-copy { margin-top: 63px; h1 { font-size: 56px; font-weight: 800; } p { font-size: 18px; } .primary-action { min-width: 174px; height: 52px; margin-top: 23px; font-size: 22px; } time { margin-top: 15px; font-size: 17px; } }
  .stat-card { padding-right: 10px; padding-left: 10px; }
  .stat-icon { width: 74px; height: 74px; margin-right: 12px; }
  .stat-content { gap: 5px; strong { font-size: 24px; font-weight: 700; } span { font-size: 16px; } em { font-size: 28px; } }
  .service-strip { min-height: 145px; padding-top: 16px; padding-bottom: 14px; img { width: 82px; height: 55px; } strong { margin-top: 5px; font-size: 22px; font-weight: 600; } span { margin-top: 5px; font-size: 17px; } }
  .mini-program-banner { min-height: 140px; padding: 0; }
  .mini-program-banner wx-open-launch-weapp { display: block; width: 100%; height: 140px; }
  .headline-heading { padding: 25px 22px 17px; h2 { font-size: 29px; } > button { font-size: 17px; } }
  .article-list { li { min-height: 240px; padding: 16px 22px 18px 40px; } li::after { right: 40px; left: 40px; } .article-index { flex-basis: 60px; box-sizing: border-box; padding-top: 8px; padding-right: 10px; font-size: 56px; line-height: 1.1; transform: scaleY(1.12); } .article-body { padding-left: 23px; } h3 { max-height: 112px; font-size: 28px; font-weight: 700; line-height: 1.4; } p { height: 52px; max-height: 52px; margin-top: 7px; font-size: 17px; line-height: 1.45; } footer { margin-top: 9px; font-size: 14px; } }
}
</style>
